import React from 'react'
import type { Brief } from 'types/brief'
import PaneItem from 'components/ui/pane-item'
import MediaItem from 'components/ui/media-item'
import { formatTimestampShort } from '@disco/utils/time-utils'
import { E2Avatar } from 'views/pages/e2/e2.prototype'
import Lozenge from 'components/ui/lozenge'
import { Flex } from 'components/ds'
import BriefStatusBadge from 'features/briefs/components/brief-status'

type Props = {
  brief: Brief
}

/**
 * Brief drag preview component that displays brief information during multi-drag
 * Shows brief details in a pane item format for drag and drop
 * @param brief - Brief item to display in the drag preview
 */
const BriefDragPreview = ({ brief }: Props) => {
  const caption = (
    <Flex mt="1" gap="1">
      <BriefStatusBadge
        submissionStatus={brief.submission_status}
        publishingStatus={brief.publishing_status}
      />
      <E2Avatar
        firstName={brief.created_by.first_name}
        lastName={brief.created_by.last_name}
        email={brief.created_by.email}
      />
      {formatTimestampShort(brief.created)}
    </Flex>
  )

  return (
    <PaneItem
      appearance="default"
      content={<MediaItem title={brief.name} caption={caption} />}
      nodeRight={<Lozenge color="gray" text={brief.response_count} />}
    />
  )
}

export default React.memo<Props>(BriefDragPreview)
